import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase'; // Firestore instance
import { collection, getDocs, onSnapshot, arrayUnion, arrayRemove } from 'firebase/firestore'; // Import onSnapshot for real-time updates
import { doc, updateDoc } from 'firebase/firestore';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
// import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BlockIcon from '@mui/icons-material/Block';
import SyncLoader from "react-spinners/SyncLoader";
import '../Component/Component.css';
import AddUserForm from './AddUserForm';
const AllowedUsersTab = ({ relay }) => {
    const [allowedUsers, setAllowedUsers] = useState([]);
    const fetchedUsersRef = useRef([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        // Replace with the actual relay ID you are using
        if (relay.relay_id == null) return;
        const relayDocRef = doc(db, 'relays', `${relay.relay_id}`); // Reference to the specific relay document

        // Listen for real-time updates
        const unsubscribe = onSnapshot(relayDocRef, (doc) => {
            if (doc.exists()) {
                const relayData = doc.data();
                const allowedUserIds = relayData.allowed_users || []; // Get allowed_users array

                // Fetch users that match the allowed_user_ids
                fetchUsers(allowedUserIds);
            } else {
                setLoading(false);
                console.log("No such document!");
            }

        }, (error) => {
            setLoading(false);
            console.error("Error fetching relay:", error);
        });

        return () => unsubscribe();
    }, [relay]);

    const fetchUsers = async (allowedUserIds) => {
        const usersCollection = collection(db, 'users');
        const usersSnapshot = await getDocs(usersCollection);
        const allUsers = usersSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        // Filter users based on allowedUserIds
        const filteredUsers = allUsers.filter(user => (allowedUserIds??[]).includes(user.id));
        fetchedUsersRef.current = [...filteredUsers];
        setAllowedUsers(filteredUsers);
        setLoading(false);
    };

    const searchUser = (text) => {
        if (text.trim() != '') {
            console.log("----------Searching users------------->")
            const lowercasedSearchText = text.toLowerCase();
            const filtered = allowedUsers.filter(user =>
                user.username.toLowerCase().includes(lowercasedSearchText)
            );
            setAllowedUsers(filtered);
        } else {
            console.log("----------Setting default users------------->" + fetchedUsersRef.current.length)
            setAllowedUsers(fetchedUsersRef.current);
        }
        // setSelectedRelay(relay);  // Update the state with the selected relay
    };

    const handleRemoveAccess = async (userId) => {
        try {
            const relayRef = doc(db, "relays", relay.id); // Reference to the specific relay document
            await updateDoc(relayRef, {
                allowed_users: arrayRemove(userId) // Remove user ID from allowed_users array
            });

            console.log(`User ${userId} removed access from ${relay.relay_name}`);
        } catch (error) {
            console.error("Error removing access:", error);
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };


    return (
        <div key="userTab" className="container-fluid tab-container">
            <div className='search-and-add-button'>
                <div className='col'>
                    <TextField id="filled-basic" label="Search User" variant="filled" onChange={(event) => {
                        searchUser(event.target.value);
                    }} sx={{
                        width: '300px',

                        '& .MuiFilledInput-root': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white',
                            textDecoration: 'none', // Remove underline
                            '&:before': { // Remove underline before focus
                                borderBottom: 'none',
                            },
                            '&:after': { // Remove underline after focus
                                borderBottom: 'none',
                            },
                            // Optional: Adjust border radius
                        },
                        '& .MuiFilledInput-root:hover': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white',
                            textDecoration: 'none', // Remove underline
                            '&:before': { // Remove underline before focus
                                borderBottom: 'none',
                            },
                            '&:after': { // Remove underline after focus
                                borderBottom: 'none',
                            },// Optional: Adjust border radius
                        },
                        '& .MuiFilledInput-root:focus': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white'// Optional: Adjust border radius
                        },
                        '& .MuiInputLabel-root': {

                            color: 'white', // Change label color
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: 'grey', // Change label color when focused
                        },
                    }} />
                </div>

                <div className='col d-flex justify-content-end padding'>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={handleClickOpen} sx={{ backgroundColor: '#3A6D8C', color: 'white', fontWeight: 'bold' }}>
                            Add New User
                        </Button>

                    </Stack>
                </div>
            </div>
            {loading ? <div className='loader-container'><SyncLoader loading={true} color='white' /></div> :
                <div className='scroll-container my-4 py-0'>
                    {
                        allowedUsers.map((user) => (
                            <div className={relay.allowed_users.includes(user.id.trim()) ? 'row all-users-container allowed-border' : 'row all-users-container not-allowed-border'}>
                                <div className='col all-user-title' key={user.username}> {user.username}</div>
                                <div className='col d-flex justify-content-end'>
                                    <Stack className='px-3' direction="row" spacing={2}>
                                        <Button variant="contained" sx={{ backgroundColor: '#FF4500', color: 'white' }} startIcon={<BlockIcon />} onClick={() => handleRemoveAccess(user.id.trim())}>
                                            Remove Acces For {relay.relay_name}
                                        </Button>

                                    </Stack>
                                    <Stack direction="row" spacing={2}>
                                        <Button variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete User
                                        </Button>

                                    </Stack>
                                </div>
                            </div>

                        ))
                    }
                </div>
            }
            <AddUserForm open={open} setOpen={setOpen} />

        </div>
    );
}

export default AllowedUsersTab;